import React from "react";
import { Link } from "react-router-dom";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";
import { FaUserPlus, FaClock, FaUser, FaCheck, FaTimes } from "react-icons/fa";
import getImageUrl from "../../../utils/imageUtils";
import FollowRequestsViewSkeleton from "./FollowRequestsViewSkeleton";

const FollowRequestsView = ({
  followRequests,
  loadingFollowRequests,
  onRefresh,
  onAccept,
  onReject,
  currentTab,
}) => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <h2 className={styles.sectionTitle}>
            <FaUserPlus className={styles.sectionIcon} />
            Follow Requests
          </h2>
          {followRequests.length > 0 && (
            <p className={styles.sectionSubtitle}>
              {followRequests.length} pending
              {followRequests.length === 1 ? " request" : " requests"}
            </p>
          )}
        </div>
        <button
          className="buttonSecondary"
          onClick={onRefresh}
          disabled={loadingFollowRequests}
          title="Refresh Requests"
        >
          <FaClock /> Refresh
        </button>
      </div>

      {loadingFollowRequests ? (
        <FollowRequestsViewSkeleton />
      ) : followRequests.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>
            <FaUserPlus size={64} />
          </div>
          <h3>No Follow Requests</h3>
          <p className={styles.emptyStateSubtext}>
            When users with private accounts want to follow you, their requests
            will appear here
          </p>
        </div>
      ) : (
        <div className={styles.requestsList}>
          {followRequests.map((request) => {
            const requester = request.requester;
            return (
              <div key={request._id} className={styles.requestCard}>
                <Link
                  to={`/user/${requester._id}`}
                  state={{ fromProfileTab: currentTab }}
                  className={styles.requestUserInfo}
                >
                  {requester.avatar ? (
                    <img
                      src={getImageUrl(requester.avatar)}
                      alt={`${requester.firstName} ${requester.lastName}`}
                      className={styles.requestAvatar}
                    />
                  ) : (
                    <div className={styles.requestAvatarPlaceholder}>
                      <FaUser />
                    </div>
                  )}
                  <div className={styles.requestUserDetails}>
                    <div className={styles.requestUserName}>
                      {requester.firstName} {requester.lastName}
                    </div>
                    {requester.username && (
                      <div className={styles.requestUsername}>
                        @{requester.username}
                      </div>
                    )}
                  </div>
                </Link>
                <div className={styles.requestActions}>
                  <button
                    className="buttonSuccess"
                    onClick={() => onAccept(request._id)}
                  >
                    <FaCheck /> Accept
                  </button>
                  <button
                    className="buttonDanger"
                    onClick={() => onReject(request._id)}
                  >
                    <FaTimes /> Reject
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default React.memo(FollowRequestsView);
